<template>
    <div class="course-detail-dialog">
        <aj-form-detail :dialogTitle="dialogTitle" :dialog-visible.sync="visible" :footer-buttons="finalFooterButtons"
            :sections="detailSections" dialogWidth="1100px" :detailData="detailData" :custom-sections="customSections">
            <!-- 版本切换自定义区域 -->
            <template #versionSwitcher>
                <div class="version-switcher-wrapper">
                    <div class="version-switcher-header">
                        <i class="el-icon-user-solid version-icon"></i>
                        <span class="version-switcher-label">选择讲师版本：</span>
                    </div>
                    <div class="version-switcher-buttons">
                        <el-button v-for="(item, index) in versionList" :key="index"
                            :type="currentVersionIndex === index ? 'primary' : 'info'" size="small"
                            class="version-switcher-btn" @click="handleVersionChange(index)">
                            <i class="el-icon-user"></i>
                            {{ item.teacherOutlineNames || '版本' + (index + 1) }}
                        </el-button>
                    </div>
                    <div class="version-current-info">
                        <el-tag type="primary" size="small" effect="dark">
                            当前版本：{{ currentVersionData?.teacherOutlineNames || '未知' }}
                        </el-tag>
                    </div>
                    <!-- 当前授课老师 -->
                    <div class="teacher-list-wrapper" v-if="teacherList.length > 0">
                        <div class="teacher-list-label">当前授课老师：</div>
                        <div class="teacher-list-tags">
                            <el-tag
                                v-for="(item, idx) in teacherList"
                                :key="idx"
                                type="info"
                                size="small"
                                class="teacher-tag">
                                {{ item.name }}
                            </el-tag>
                        </div>
                    </div>
                    <!-- 课程负责人 -->
                    <!-- 课程负责人 -->
                    <div class="teacher-list-wrapper" v-if="detailData.courseCharge">
                        <div class="teacher-list-label">当前课程负责人：</div>
                        <div class="teacher-list-tags">
                            <el-tag
                                type="info"
                                size="small"
                                class="teacher-tag">
                                {{ detailData.courseCharge }}
                            </el-tag>
                        </div>
                    </div>
                </div>
            </template>
        </aj-form-detail>
        <AiLogicDiagram :dialog-title="'课程大纲逻辑图'" :dialog-visible.sync="showLuoJiTu" :dialog-width="'1200px'"
            :detail-data="detailDataJson" @save-optimized="handleSaveOptimized" @regenerate="handleRegenerate" />

        <!-- 课程评论弹框 -->
        <el-dialog title="课程评论" :visible.sync="showComment" width="700px" append-to-body class="comment-dialog">
            <div slot="title" class="comment-dialog-header">
                <i class="el-icon-chat-line-round"></i>
                <span>课程评论</span>
            </div>
            <div class="comment-container">
                <!-- 评论列表 -->
                <div class="comment-list-wrapper">
                    <el-empty v-if="commentList.length === 0 && !commentLoading" description="暂无评论"></el-empty>
                    <div v-else class="comment-list">
                        <div v-for="comment in commentList" :key="comment.courseCommentId" class="comment-item">
                            <div class="comment-header">
                                <div class="comment-author-wrapper">
                                    <!-- 头像 -->
                                    <div class="comment-avatar" v-if="comment.userAvatar">
                                        <img :src="comment.userAvatar" alt="avatar" />
                                    </div>
                                    <div class="comment-avatar comment-avatar-text" v-else>
                                        {{ getAvatarText(comment.userName) }}
                                    </div>
                                    <span class="comment-author">{{ comment.userName || '匿名用户' }}</span>
                                </div>
                                <span class="comment-time">{{ comment.createtime }}</span>
                            </div>
                            <div class="comment-content">{{ comment.content }}</div>
                            <div class="comment-actions">
                                <el-button type="text" size="small" @click="replyTo(comment)">回复</el-button>
                                <el-button v-if="canDeleteThisComment(comment.userId)" type="text" size="small" style="color: #F56C6C" @click="deleteComment(comment.courseCommentId, comment.userId)">删除</el-button>
                                <!-- 展开评论按钮 -->
                                <el-button v-if="comment.courseCommentChildNums > 0" type="text" size="small" class="expand-btn" @click="toggleChildren(comment)">
                                    <i :class="comment.showChildren ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                    {{ comment.showChildren ? '收起' : '展开' }}{{ comment.courseCommentChildNums }}条回复
                                </el-button>
                            </div>
                            <!-- 子评论列表 -->
                            <div v-if="comment.showChildren && comment.children && comment.children.length > 0" class="comment-children">
                                <div v-for="child in comment.children" :key="child.courseCommentId" class="comment-child">
                                    <div class="comment-child-header">
                                        <div class="comment-author-wrapper">
                                            <!-- 头像 -->
                                            <div class="comment-avatar comment-avatar-sm" v-if="child.userAvatar">
                                                <img :src="child.userAvatar" alt="avatar" />
                                            </div>
                                            <div class="comment-avatar comment-avatar-text comment-avatar-sm" v-else>
                                                {{ getAvatarText(child.userName) }}
                                            </div>
                                            <span class="comment-author">{{ child.userName || '匿名用户' }}</span>
                                        </div>
                                        <div class="comment-child-actions">
                                            <span class="comment-time">{{ child.createtime }}</span>
                                            <el-button v-if="canDeleteThisComment(child.userId)" type="text" size="mini" style="color: #F56C6C; padding: 0;" @click="deleteComment(child.courseCommentId, child.userId)">删除</el-button>
                                        </div>
                                    </div>
                                    <div class="comment-child-content">
                                        <span v-if="child.toUserName" class="reply-name">@{{ child.toUserName }}：</span>
                                        {{ child.content }}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 分页 -->
                    <el-pagination
                        v-if="commentPagination.total > 0"
                        small
                        layout="prev, pager, next"
                        :total="commentPagination.total"
                        :page-size="commentPagination.pageSize"
                        :current-page="commentPagination.currentPage"
                        @current-change="handleCommentPageChange"
                        style="text-align: center; margin-top: 12px;"
                    />
                </div>

                <!-- 评论输入框 -->
                <div class="comment-input-wrapper">
                    <el-input
                        v-model="commentForm.content"
                        type="textarea"
                        :rows="2"
                        :placeholder="commentForm.replyTo ? '回复 ' + commentForm.replyTo : '请输入评论内容'"
                    />
                    <div class="comment-input-actions">
                        <el-button v-if="commentForm.replyTo" size="small" @click="cancelReply">取消回复</el-button>
                        <el-button type="primary" size="small" @click="submitComment" :disabled="!commentForm.content.trim()">发表评论</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ajFormDetail from '@/components/ajForm/ajFormDetail.vue';
import AiLogicDiagram from '@/components/page_components/AiLogicDiagram.vue';
import { getAjCourseDetails, getAjCourseOutlineDiagramAi,updateAjCourseDownloadNumAddOne, getAjCourseCommentList, deleteAjCourseComment, addAjCourseComment } from '@/api/api';
import { exportCourseWord, selectTemplateByHighlights, loadLocalTemplateLibrary, getPreloadedTemplateLibrary, parseBenefits } from '../../utils/wordExport';

export default {
    name: 'CourseDetailDialog',
    components: {
        ajFormDetail, AiLogicDiagram
    },
    props: {
        // 课程ID
        courseId: {
            type: [String, Number],
            default: null
        },
        // 弹窗标题
        dialogTitle: {
            type: String,
            default: '课程详情'
        },
        // 弹窗宽度
        dialogWidth: {
            type: [String, Number],
            default: '1100px'
        },
        // 自定义底部按钮（由父组件传入）
        footerButtons: {
            type: Array,
            default: null
        },
        // 外部传入的详情数据（如果有则直接使用，不调用接口）
        externalDetailData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            showLuoJiTu: false,
            detailDataJson: {},
            visible: false,
            detailData: {},
            detailSections: [],
            currentVersionIndex: 0,  // 当前选中的版本索引
            // 课程评论相关
            showComment: false,
            commentList: [],
            commentLoading: false,
            commentPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            commentForm: {
                content: '',
                parentId: null,
                replyTo: null
            },
            // 展开/收起子评论的状态
            expandedComments: new Set(),
            // 头像文字辅助函数
            getAvatarText: (name) => {
                if (!name) return '匿名';
                return name.slice(-2);
            }
        };
    },
    computed: {
        // 判断是否是系统管理员
        isSystemAdmin() {
            // 从localStorage获取用户岗位信息，auPost === 1 表示系统管理员
            const userPost = localStorage.getItem('zhikeTong_userPost');
            return userPost === '1';
        },
        // 当前用户ID
        currentUserId() {
            // 从localStorage获取当前用户ID
            return localStorage.getItem('zhikeTong_userId') || null;
        },
        // 最终使用的底部按钮（优先使用父组件传入的）
        finalFooterButtons() {
            // 如果父组件传入了 footerButtons，则使用父组件的
            if (this.footerButtons && this.footerButtons.length > 0) {
                return this.footerButtons;
            }
            // 否则使用默认按钮
            const buttons = [
                {
                    text: '下载Word',
                    type: 'success',
                    icon: 'el-icon-download',
                    onClick: this.handleDownload,
                    class: 'btn-download'
                },
                {
                    text: 'AI优化',
                    type: 'primary',
                    icon: 'el-icon-magic-stick',
                    onClick: this.handleAiOptimize,
                    class: 'btn-ai'
                },
                {
                    text: '生成大纲逻辑图',
                    type: 'primary',
                    icon: 'el-icon-magic-stick',
                    onClick: this.handleAiLogIc
                },
                {
                    text: '课程评论',
                    type: 'warning',
                    icon: 'el-icon-chat-line-round',
                    onClick: this.handleOpenComment
                },
                { text: '关闭', plain: true }
            ];
            return buttons;
        },
        // 当前版本数据
        currentVersionData() {
            if (
                !this.detailData.ajCourseOutlineList ||
                !Array.isArray(this.detailData.ajCourseOutlineList) ||
                this.detailData.ajCourseOutlineList.length === 0
            ) {
                return null;
            }
            return this.detailData.ajCourseOutlineList[this.currentVersionIndex];
        },
        // 所有版本列表
        versionList() {
            return this.detailData.ajCourseOutlineList || [];
        },
        // 自定义区域配置
        customSections() {
            return [
                {
                    slotName: 'versionSwitcher',
                    title: '版本切换',
                    order: 2
                }
            ];
        },
        // 授课老师列表
        teacherList() {
            const ids = this.parseJsonArray(this.currentVersionData?.teacherOutlineIdsTwo);
            const names = this.currentVersionData?.teacherOutlineNamesTwo?.split(',') || [];
            if (!ids || ids.length === 0 || names.length === 0) return [];
            return names.map((name, idx) => ({
                id: ids[idx] || null,
                name: name.trim()
            })).filter(item => item.id && item.name);
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadCourseDetail();
            }
        }
    },
    methods: {
        // 判断某条评论是否可以被当前用户删除
        canDeleteThisComment(createId) {
            // 如果没有传入创建者ID或当前用户未登录，返回false
            if (!createId || !this.currentUserId) return false;
            // 管理员可以删除
            if (this.isSystemAdmin) return true;
            // 评论发布者可以删除（使用字符串比较避免类型问题）
            if (String(createId) === String(this.currentUserId)) return true;
            return false;
        },
        // 解析JSON数组字符串
        parseJsonArray(str) {
            if (!str) return [];
            try {
                return JSON.parse(str);
            } catch (e) {
                return [];
            }
        },
        handleSaveOptimized(data) {
            console.log('【保存优化】接收到数据:', data);
            this.$message.success('已保存优化方案！');
        },
        handleRegenerate() {
            console.log('【重新生成】触发');
            this.$message.info('正在调用AI重新生成...');
            // 这里可以调用API重新获取 detailData
        },
        // 打开大纲逻辑图
        handleAiLogIc() {
            this.$loading.show()
            getAjCourseOutlineDiagramAi({ acoId: this.currentVersionData.acoId }).then(res => {
                if(res){
                    this.showLuoJiTu = true;
                    this.detailDataJson = res.data
                    this.$loading.close()
                }
            })
        },
        // 打开弹窗
        open() {
            this.visible = true;
        },
        // 直接设置详情数据（用于暂存区查看）
        setDetailData(detailData) {
            this.detailData = detailData;
            this.currentVersionIndex = 0;
            this.updateDetailSections();
            this.$emit('getDetailData', {
                data: detailData.ajCourseOutlineList,
                index: this.currentVersionIndex
            });
        },
        // 关闭弹窗
        close() {
            this.visible = false;
        },
        // 版本切换
        handleVersionChange(index) {
            this.currentVersionIndex = index;
            this.updateDetailSections();
            // 通知父组件版本切换了，需要检查选中状态
            this.$emit('getDetailData', {
                data: this.detailData.ajCourseOutlineList,
                index: this.currentVersionIndex
            });
        },
        // 加载课程详情
        async loadCourseDetail() {
            try {
                // 如果外部传入了详情数据，直接使用
                if (this.externalDetailData && Object.keys(this.externalDetailData).length > 0) {
                    this.detailData = this.externalDetailData;
                    this.currentVersionIndex = 0;
                    this.updateDetailSections();
                    this.$emit('getDetailData', {
                        data: this.detailData.ajCourseOutlineList,
                        index: this.currentVersionIndex
                    });
                    return;
                }

                // 否则调用接口获取
                const res = await getAjCourseDetails({ courseId: this.courseId });
                console.log(res);

                if (res.status == 200) {
                    this.detailData = res.data;
                    this.currentVersionIndex = 0;  // 重置为第一个版本
                    // 构建 sections 数据
                    this.updateDetailSections();
                    this.$emit('getDetailData',{data:res.data.ajCourseOutlineList,index:this.currentVersionIndex})
                }
            } catch (error) {
                console.error('获取课程详情失败:', error);
                this.$message.error('获取课程详情失败');
            }
        },
        // 根据当前版本更新详情字段
        updateDetailSections() {
            const versionData = this.currentVersionData;
            const baseData = this.detailData;

            if (!versionData) {
                this.detailSections = [];
                return;
            }

            // 构建详情字段
            this.detailSections = [
                { title: '课程名称', icon: 'info', type: 'text', content: versionData.courseTitle || '-' },
                { title: '课程分类', icon: 'info', type: 'text', content: versionData.accName || '-' },
                { title: '适用层级', icon: 'info', type: 'text', content: versionData.acsuName || '-' },
                { title: '教学时长', icon: 'info', type: 'text', content: versionData.courseStyle ? versionData.courseStyle : '-' },
                { title: '教学方式', icon: 'info', type: 'text', content: versionData.courseStyleDes || '-' },
                { title: '课程简介', icon: 'info', type: 'text', content: versionData.courseIntroduce || '-' },
                { title: '教学目标', icon: 'info', type: 'text', content: versionData.courseTarget || '-' },
                { title: '特色亮点', icon: 'info', type: 'text', content: versionData.courseSpecialty || '-' },
                { title: '预期成果', icon: 'info', type: 'text', content: versionData.courseExpectedOutcome || '-' },
                { title: '课程大纲', icon: 'info', type: 'text', content: versionData.courseOutline || '-' }
            ];
        },
        // 下载文档
        async handleDownload() {
            try {
                const versionData = this.currentVersionData;
                if (!versionData) {
                    this.$message.warning('暂无大纲数据');
                    return;
                }

                const templateLibrary = getPreloadedTemplateLibrary();
                if (!templateLibrary || Object.keys(templateLibrary).length === 0) {
                    // 尝试加载本地模板库
                    await loadLocalTemplateLibrary('/templates');
                }

                const dataToExport = { ...this.detailData, ...versionData };
                // 根据预期成果数量选择模板
                const benefitsCount = parseBenefits(dataToExport.courseExpectedOutcome || dataToExport.benefits || '').length;
                console.log('导出使用：预期成果数量=' + benefitsCount + '，选择模板' + benefitsCount + '个');
                const template = selectTemplateByHighlights(
                    benefitsCount,
                    getPreloadedTemplateLibrary()
                );

                if (!template) {
                    this.$message.error('未找到合适的模板');
                    return;
                }

                await exportCourseWord([dataToExport], { template });
                 updateAjCourseDownloadNumAddOne({ acoIds:JSON.stringify([versionData.acoId])})
                this.$message.success('文档导出成功');
            } catch (error) {
                console.error('Word导出失败:', error);
                this.$message.error('导出Word失败：' + (error.message || '未知错误'));
            }
        },
        // AI优化
        handleAiOptimize() {
            this.$emit('ai-optimize', { courseData: this.detailData, versionIndex: this.currentVersionIndex });
        },
        // 打开课程评论
        handleOpenComment() {
            this.showComment = true;
            console.log('打卡');
            
            this.resetCommentForm();
            this.loadCommentList();
        },
        // 重置评论表单
        resetCommentForm() {
            this.commentForm = {
                content: '',
                parentId: null,
                replyTo: null
            };
        },
        // 加载评论列表
        loadCommentList() {
            this.commentLoading = true;
            const params = {
                courseId: this.courseId,
                currentPage: this.commentPagination.currentPage,
                pageSize: this.commentPagination.pageSize
            };
            // 统一使用getAjCourseCommentList接口
            const api = getAjCourseCommentList;
            api(params).then(res => {
                if (res.status == 200 && res.data) {
                    // data可能是数组（直接返回列表）或对象（分页返回）
                    if (Array.isArray(res.data)) {
                        this.commentList = res.data;
                        this.commentPagination.total = res.data.length || 0;
                    } else {
                        this.commentList = res.data.rows || [];
                        this.commentPagination.total = res.data.total || 0;
                    }
                    // 处理子评论
                    this.commentList = this.commentList.map(item => {
                        item.children = item.children || [];
                        // 使用接口返回的 courseCommentChildNums，如果没有则默认0
                        // 确保是数字类型
                        item.courseCommentChildNums = Number(item.courseCommentChildNums) || 0;
                        // 默认不展开子评论
                        item.showChildren = false;
                        return item;
                    });
                }
            }).finally(() => {
                this.commentLoading = false;
            });
        },
        // 评论分页变化
        handleCommentPageChange(page) {
            this.commentPagination.currentPage = page;
            this.loadCommentList();
        },
        // 展开/收起子评论
        toggleChildren(comment) {
            const willShow = !comment.showChildren;
            // 如果是要展开子评论，且还没有加载过子评论，则调用接口获取
            if (willShow && (!comment.children || comment.children.length === 0)) {
                // 先设置为true，让用户看到展开状态
                this.$set(comment, 'showChildren', true);
                this.loadChildComments(comment);
            } else {
                this.$set(comment, 'showChildren', willShow);
            }
        },
        // 加载子评论列表
        loadChildComments(parentComment) {
            const params = {
                courseId: this.courseId,
                courseCommentParentId: parentComment.courseCommentId
            };
            getAjCourseCommentList(params).then(res => {
                if (res.status == 200 && res.data) {
                    const children = Array.isArray(res.data) ? res.data : (res.data.rows || []);
                    console.log('children data:', children, 'length:', children.length);

                    // 通过在 commentList 中找到对应评论并更新
                    const commentId = parentComment.courseCommentId;
                    const index = this.commentList.findIndex(c => c.courseCommentId === commentId);

                    if (index !== -1) {
                        // 替换整个评论对象，确保响应式更新
                        const updatedComment = {
                            ...this.commentList[index],
                            children: children,
                            showChildren: true
                        };
                        this.commentList.splice(index, 1, updatedComment);
                    }
                }
            }).catch(err => {
                console.error('loadChildComments error:', err);
            });
        },
        // 回复评论
        replyTo(comment, parentComment = null) {
            this.commentForm.parentId = comment.courseCommentId;
            this.commentForm.replyTo = comment.userName || '匿名用户';
            // 如果有父评论，parentId应该是父评论的id
            if (parentComment) {
                this.commentForm.parentId = parentComment.courseCommentId;
            }
        },
        // 取消回复
        cancelReply() {
            this.resetCommentForm();
        },
        // 提交评论
        submitComment() {
            if (!this.commentForm.content.trim()) {
                this.$message.warning('请输入评论内容');
                return;
            }
            const params = {
                courseId: this.courseId,
                content: this.commentForm.content.trim()
            };
            if (this.commentForm.parentId) {
                params.courseCommentParentId = this.commentForm.parentId;
            }
            addAjCourseComment(params).then(res => {
                if (res.status == 200) {
                    this.$message.success('评论成功');
                    this.resetCommentForm();
                    this.loadCommentList();
                } else {
                    this.$message.error(res.msg || '评论失败');
                }
            });
        },
        // 删除评论
        deleteComment(commentId, createId) {
            // 检查权限：系统管理员或评论发布者才能删除
            if (!this.isSystemAdmin && (!createId || !this.currentUserId || String(createId) !== String(this.currentUserId))) {
                this.$message.warning('您没有权限删除此评论');
                return;
            }
            this.$confirm('确定删除该评论吗？', '提示', {
                type: 'warning'
            }).then(() => {
                deleteAjCourseComment({ courseCommentId: commentId }).then(res => {
                    if (res.status == 200) {
                        this.$message.success('删除成功');
                        this.loadCommentList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
/* 版本切换区域样式 */
.version-switcher-wrapper {
    padding: 20px 24px;
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
    border-radius: 14px;
    border: 2px solid rgba(139, 92, 246, 0.15);
    margin: 10px 0;
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.08);
    position: relative;
    overflow: hidden;
}

.version-switcher-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
    background-size: 200% 100%;
}

.version-switcher-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.version-icon {
    font-size: 20px;
    color: #667eea;
    margin-right: 10px;
    text-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.version-switcher-label {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.version-switcher-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
}

.version-switcher-btn {
    border-radius: 10px !important;
    font-weight: 600 !important;
    padding: 10px 20px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border: 2px solid transparent !important;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
    color: #64748b !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

.version-switcher-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.25) !important;
    border-color: #667eea !important;
}

.version-switcher-btn.el-button--primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-color: transparent !important;
    box-shadow: 0 4px 14px rgba(102, 126, 234, 0.4) !important;
    color: #fff !important;
}

.version-switcher-btn.el-button--primary:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.5) !important;
}

.version-current-info {
    padding-top: 12px;
    border-top: 1px dashed rgba(139, 92, 246, 0.2);
}

.version-current-info .el-tag {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-color: transparent !important;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 授课老师列表样式 */
.teacher-list-wrapper {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed rgba(139, 92, 246, 0.2);
}

.teacher-list-label {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.teacher-list-label::before {
    content: '';
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #667eea, #764ba2);
    border-radius: 2px;
}

.teacher-list-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.teacher-tag {
    border-radius: 6px !important;
    font-weight: 500 !important;
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%) !important;
    border-color: rgba(102, 126, 234, 0.2) !important;
    color: #667eea !important;
}

/* 底部操作按钮区域 */
.detail-footer-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
    padding: 24px;
    background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
    border-top: 1px solid #f0f0f0;
    margin-top: 10px;
    position: relative;
}

.detail-footer-actions::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 2px;
    background: linear-gradient(90deg, transparent, #667eea, transparent);
}

.action-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 32px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: none;
    position: relative;
    overflow: hidden;
}

.action-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
}

.action-btn:hover::before {
    left: 100%;
}

.action-btn-download {
    background: linear-gradient(135deg, #67c23a 0%, #529e2c 100%);
    color: white;
    box-shadow: 0 4px 16px rgba(103, 194, 58, 0.35);
}

.action-btn-download:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(103, 194, 58, 0.45);
}

.action-btn-ai {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35);
}

.action-btn-ai:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(102, 126, 234, 0.45);
}

.action-btn-ai i,
.action-btn-download i {
    font-size: 16px;
}

/* 选用按钮样式 */
:deep(.btn-select) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-color: transparent !important;
    color: #fff !important;
    font-weight: 600 !important;
    border-radius: 10px !important;
    padding: 10px 24px !important;
    box-shadow: 0 4px 14px rgba(102, 126, 234, 0.35) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

:deep(.btn-select:hover) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45) !important;
}

/* 选中状态 - 已选用 */
:deep(.btn-select.btn-selected) {
    background: linear-gradient(135deg, #67c23a 0%, #529e2c 100%) !important;
    box-shadow: 0 4px 14px rgba(103, 194, 58, 0.35) !important;
}

:deep(.btn-select.btn-selected):hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(103, 194, 58, 0.45) !important;
}

/* 下载按钮样式 */
:deep(.btn-download) {
    border-radius: 10px !important;
    font-weight: 600 !important;
    padding: 10px 24px !important;
    background: linear-gradient(135deg, #67c23a 0%, #529e2c 100%) !important;
    border-color: transparent !important;
    box-shadow: 0 4px 14px rgba(103, 194, 58, 0.35) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

:deep(.btn-download:hover) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(103, 194, 58, 0.45) !important;
}

/* AI优化按钮样式 */
:deep(.btn-ai) {
    border-radius: 10px !important;
    font-weight: 600 !important;
    padding: 10px 24px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-color: transparent !important;
    box-shadow: 0 4px 14px rgba(102, 126, 234, 0.35) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

:deep(.btn-ai:hover) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45) !important;
}

/* 课程详情卡片增强样式 */
:deep(.detail-section-title) {
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #1e293b !important;
    padding: 16px 20px !important;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    border-bottom: 2px solid #667eea !important;
    position: relative;
}

:deep(.detail-section-title)::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 20px;
    width: 40px;
    height: 2px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    border-radius: 1px;
}

:deep(.detail-content-item) {
    padding: 14px 20px !important;
    border-bottom: 1px solid #f1f5f9 !important;
    transition: all 0.2s ease;
}

:deep(.detail-content-item:hover) {
    background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%) !important;
}

:deep(.detail-label) {
    color: #64748b !important;
    font-weight: 500 !important;
    font-size: 13px !important;
}

:deep(.detail-value) {
    color: #1e293b !important;
    font-weight: 600 !important;
    font-size: 14px !important;
}

/* 弹窗头部样式 */
:deep(.aj-dialog__header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    padding: 20px 24px !important;
    border-radius: 8px 8px 0 0 !important;
}

:deep(.aj-dialog__title) {
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 18px !important;
}

:deep(.aj-dialog__headerbtn) {
    top: 20px !important;
}

:deep(.aj-dialog__headerbtn .aj-dialog__close) {
    color: #fff !important;
}

:deep(.aj-dialog__headerbtn:hover) {
    background: rgba(255, 255, 255, 0.1) !important;
}

/* 详情卡片边框样式 */
:deep(.detail-section) {
    border: 1px solid #e4e7ed !important;
    border-radius: 12px !important;
    margin: 16px 20px !important;
    overflow: hidden !important;
    background: #fff !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;
}

:deep(.detail-section-title) {
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #1e293b !important;
    padding: 16px 20px !important;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    border-bottom: 2px solid #667eea !important;
    position: relative;
    margin-bottom: 0 !important;
}

/* 课程评论样式 */
/* 弹框头部自定义 */
.comment-dialog-header {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
}

.comment-dialog-header i {
    font-size: 20px;
}

:deep(.comment-dialog .el-dialog__header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 14px 20px;
    border-radius: 8px 8px 0 0;
}

:deep(.comment-dialog .el-dialog__title) {
    color: #fff;
}

:deep(.comment-dialog .el-dialog__headerbtn) {
    top: 14px;
}

:deep(.comment-dialog .el-dialog__headerbtn .el-dialog__close) {
    color: #fff;
}

:deep(.comment-dialog .el-dialog__body) {
    padding: 16px 20px;
}

.comment-container {
    display: flex;
    flex-direction: column;
    max-height: 60vh;
    overflow: hidden;
}

.comment-list-wrapper {
    flex: 1;
    overflow-y: auto;
    padding-right: 5px;
}

.comment-list {
    max-height: 100%;
}

:deep(.comment-list::-webkit-scrollbar) {
    width: 4px;
}

:deep(.comment-list::-webkit-scrollbar-thumb) {
    background: rgba(102, 126, 234, 0.2);
    border-radius: 2px;
}

/* 评论输入框 */
.comment-input-wrapper {
    flex-shrink: 0;
    padding-top: 12px;
    border-top: 1px dashed rgba(102, 126, 234, 0.2);
    margin-top: 12px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 12px;
    border-radius: 8px;
}

:deep(.comment-input-wrapper .el-textarea__inner) {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    resize: none;
    font-family: inherit;
}

:deep(.comment-input-wrapper .el-textarea__inner:focus) {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.comment-input-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    gap: 8px;
}

:deep(.comment-input-actions .el-button--primary) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 6px;
    font-weight: 500;
}

:deep(.comment-input-actions .el-button--primary:hover) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

:deep(.comment-input-actions .el-button--default) {
    border-radius: 6px;
    border-color: #e4e7ed;
    color: #606266;
}

/* 评论卡片 */
.comment-item {
    padding: 8px 10px;
    background: #fafbfc;
    border-radius: 6px;
    margin-bottom: 6px;
    border: 1px solid #f0f0f0;
    transition: all 0.2s ease;
}

.comment-item:hover {
    border-color: rgba(102, 126, 234, 0.2);
    background: #fff;
}

.comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.comment-author-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.comment-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 1px solid rgba(102, 126, 234, 0.3);
}

.comment-avatar-sm {
    width: 26px;
    height: 26px;
    font-size: 10px !important;
}

.comment-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.comment-avatar-text {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}

.comment-author {
    font-weight: 500;
    color: #303133;
    font-size: 13px;
}

.comment-time {
    font-size: 10px;
    color: #909399;
}

.comment-content {
    color: #606266;
    line-height: 1.5;
    margin-bottom: 4px;
    padding-left: 40px;
    font-size: 12px;
}

.comment-actions {
    display: flex;
    gap: 6px;
    padding-left: 40px;
    font-size: 11px;
}

:deep(.comment-actions .el-button--text) {
    color: #667eea;
    font-weight: 400;
    padding: 1px 4px;
    font-size: 11px;
}

:deep(.comment-actions .el-button--text:hover) {
    background: rgba(102, 126, 234, 0.1);
    border-radius: 3px;
}

/* 展开按钮 */
.expand-btn {
    color: #667eea !important;
    font-weight: 400 !important;
    white-space: nowrap;
    font-size: 11px !important;
}

.expand-btn i {
    margin-right: 2px;
}

/* 子评论 */
.comment-children {
    margin-left: 30px;
    margin-top: 4px;
    padding-left: 8px;
    border-left: 1px solid #e4e7ed;
}

.comment-child {
    background: #f8f9fa;
    margin-bottom: 4px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    padding: 6px 8px;
}

.comment-child-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
}

.comment-child-actions {
    display: flex;
    gap: 4px;
}

.comment-child-content {
    color: #606266;
    line-height: 1.4;
    font-size: 11px;
}

.reply-name {
    color: #409eff;
    font-weight: 500;
}
</style>
